<form [formGroup]="messageForm" class="msg-form">

  <div class="form-sections">

    <section class="form-section">
      <div class="form-panel-body">
        <div class="panel-body-option">
          <button
            type="button"
            class="option-chip"
            [class.is-selected]="message.timeIntervalEnabled"
            [disabled]="isReadOnly()"
            (click)="onTimeIntervalToggle()">
            <mat-icon>{{ message.timeIntervalEnabled ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
            Tidsintervall
          </button>
        </div>
        <div class="datetime-grid">
          <div class="datetime-dates">
            <div class="datetime-field">
              <div class="field-label-row">
                <span class="field-label">Visas från</span>
                @if (showErrors('validFrom') && errorMessage('validFrom')) {
                  <span class="field-error">{{ errorMessage("validFrom") }}</span>
                }
              </div>
              <app-datetime-field
                [value]="message.validFrom"
                (valueChange)="onDateChange($event, 'validFrom')"
                (invalidChange)="onDateTextInvalid($event, 'validFrom')"
                placeholder="Nu"
                [disabled]="isReadOnly()">
              </app-datetime-field>
            </div>
            <div class="datetime-field">
              <div class="field-label-row">
                <span class="field-label">Visas till</span>
                @if (showErrors('validTo') && errorMessage('validTo')) {
                  <span class="field-error">{{ errorMessage("validTo") }}</span>
                }
              </div>
              <app-datetime-field
                [value]="message.validTo"
                [min]="message.validFrom"
                (valueChange)="onDateChange($event, 'validTo')"
                (invalidChange)="onDateTextInvalid($event, 'validTo')"
                placeholder="Tills vidare"
                [disabled]="isReadOnly()">
              </app-datetime-field>
            </div>
          </div>
          <div class="datetime-times">
            <div class="datetime-field" [class.datetime-field--inactive]="!message.timeIntervalEnabled && !isReadOnly()">
              <div class="field-label-row">
                <span class="field-label">Starttid</span>
              </div>
              <app-datetime-field
                mode="time"
                [value]="getTimeAsDate(message.timeIntervalStart)"
                (valueChange)="onTimeIntervalChange($event, 'start')"
                [disabled]="isReadOnly() || !message.timeIntervalEnabled">
              </app-datetime-field>
            </div>
            <div class="datetime-field" [class.datetime-field--inactive]="!message.timeIntervalEnabled && !isReadOnly()">
              <div class="field-label-row">
                <span class="field-label">Sluttid</span>
              </div>
              <app-datetime-field
                mode="time"
                [value]="getTimeAsDate(message.timeIntervalEnd)"
                (valueChange)="onTimeIntervalChange($event, 'end')"
                [disabled]="isReadOnly() || !message.timeIntervalEnabled">
              </app-datetime-field>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="form-section">
      <div class="form-section-header">
        <span class="field-label">Namn</span>
        @if (!isReadOnly()) {
          <span class="field-required">*</span>
        }
        @if (!isReadOnly()) {
          <span class="field-meta">{{ getCount("heading") }}/{{ maxLength.heading }}</span>
        }
      </div>
      <div class="form-panel-body form-panel-body--compact">
        <div class="form-field form-field--full">
          @if (showErrors('heading')) {
            <span class="field-error">{{ errorMessage("heading") }}</span>
          }
          @if (!isReadOnly()) {
            <textarea
              formControlName="heading"
              [ngClass]="{ 'error-input': showErrors('heading') }"
              class="expanding-textarea"
              id="headingDiv"
              [attr.maxlength]="maxLength.heading"
              (paste)="onTextboxPaste($event, 'heading', maxLength.heading, true)"
              (input)="onTextboxChange($event, 'heading', maxLength.heading, true)"
            (keydown)="limitUserInput($event, maxLength.heading)"></textarea>
          }
          @if (isReadOnly()) {
            <textarea
              formControlName="heading"
              class="expanding-textarea disabled"
              id="headingDiv2"
            readonly></textarea>
          }
        </div>
      </div>
    </section>

    <section class="form-section">
      <div class="form-section-header">
        <span class="field-label">Meddelandetext</span>
        @if (!isReadOnly()) {
          <span class="field-required">*</span>
        }
        @if (!isReadOnly()) {
          <span class="field-meta">{{ getCount("body") }}/{{ maxLength.body }}</span>
        }
      </div>
      <div class="form-panel-body form-panel-body--compact">
        <div class="form-field form-field--full">
          @if (showErrors('body')) {
            <span class="field-error">{{ errorMessage("body") }}</span>
          }
          @if (!isReadOnly()) {
            <textarea
              [ngClass]="{ 'error-input': showErrors('body') }"
              contenteditable="true"
              class="expanding-textarea"
              id="bodyDiv"
              [value]="messageForm.get('body')!.value"
              [maxLength]="maxLength.body"
              (paste)="onTextboxPaste($event, 'body', maxLength.body, true)"
              (keyup)="onTextboxChange($event, 'body', maxLength.body, true)"
            (keydown)="limitUserInput($event, maxLength.body)"></textarea>
          }
          @if (isReadOnly()) {
            <textarea
              disabled
              contenteditable="false"
              [value]="this.messageForm.get('body')!.value || ''"
              class="expanding-textarea disabled"
            id="bodyDiv2"></textarea>
          }
        </div>
      </div>
    </section>

  </div>

</form>
